import { Alert, Button, Modal, Select } from "flowbite-react";
import { useEffect, useState } from "react";
import { AiOutlineLoading } from "react-icons/ai";
import { HiOutlineExclamationCircle } from "react-icons/hi";

const ModalCancelCV = ({
  handleDelete,
  isOpen,
  setOpenModal,
  title,
  isLoading,
  selectedCv,
  error,
}) => {
  const [selectedOption, setSelectedOption] = useState({ id: "", label: "" });

  const handleSelectChange = (e) => {
    const selectedId = e.target.value;
    const selectedLabel = e.target.options[e.target.selectedIndex].text;

    setSelectedOption({
      id: selectedId,
      label: selectedLabel,
    });
  };

  useEffect(() => {
    setSelectedOption("");
  }, [selectedCv]);

  return (
    <>
      <Modal show={isOpen} size="md" onClose={() => setOpenModal(false)} popup>
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
            <h3 className="mb-2 text-lg font-normal text-gray-500 dark:text-gray-400">
              {title}
            </h3>
            <div className="mb-10">
              <div className="font-semibold text-sm mb-1">
                Motivo do cancelamento:
              </div>
              <Select onChange={handleSelectChange} value={selectedOption.id}>
                <option value="" disabled>
                  Selecione
                </option>
                <option value="1">Registro Indevido</option>
                <option value="2">Dados incorretos</option>
                <option value="3">Desistência</option>
                <option value="4">Processo administrativo</option>
                <option value="5">Determinação judicial</option>{" "}
                <option value="6">Veículo com restrição RFB</option>
              </Select>
            </div>
            <div className="flex justify-center gap-4">
              <Button
                color="failure"
                onClick={() => handleDelete(selectedOption)}
                isProcessing={isLoading}
                processingSpinner={
                  <AiOutlineLoading className="h-6 w-6 animate-spin" />
                }
                disabled={selectedOption === "" || isLoading}
              >
                Confirmar
              </Button>
              <Button color="gray" onClick={() => setOpenModal(false)}>
                Cancelar
              </Button>
            </div>
          </div>
          {error && (
            <Alert color="failure" className="mt-2" withBorderAccent>
              {error}
            </Alert>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalCancelCV;
